<section class="disclaimer">
  <div class="container">
    <div class="row justify-content-center text-center small text-muted">
      <div class="col-sm-9 col-md-6">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</section>
